/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SharedContactDealerWrapper_item$ref = any;
export type SharedContactDealerWrapper_item = {
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly serviceId: string | null;
    readonly " $refType": SharedContactDealerWrapper_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "SharedContactDealerWrapper_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            (v0 /*: any*/)
        ]
    } as any;
})();
(node as any).hash = '70e31ce2cc08365ed74962bdbf7ac3e9';
export default node;
